export const MUTATION_GROUP = 'singleGroupPickerFields' as const;
